import apiFetch from "../../context/api";

/**
 * La estación de impresión, vista desde el navegador.
 *
 * La barra tiene UNA impresora y varias pantallas mirando la misma cola. El servidor
 * es lo único que ven todas, así que ahí viven las dos cosas que antes guardaba cada
 * aparato por su cuenta: quién imprime, y qué comandas ya salieron.
 *
 * Todas estas llamadas fallan en silencio devolviendo `null`: un corte de red no puede
 * tumbar la pantalla de Barra, que es lo que sostiene el servicio.
 */

/** Cada cuánto dice la estación «sigo aquí». El backend la caduca a los 60 s. */
export const LATIDO_MS = 15000;

async function pedir(ruta, opciones) {
  try {
    const res = await apiFetch(ruta, opciones);
    if (!res.ok) return null;
    const tipo = (res.headers.get("content-type") || "").toLowerCase();
    return tipo.includes("application/json") ? await res.json() : {};
  } catch {
    return null;
  }
}

const conJson = (headers) => ({ ...headers, "Content-Type": "application/json" });

/** «Yo tengo la impresora», con el nombre que le puso quien la configuró. */
export function latir(venueID, etiqueta, headers) {
  return pedir("/v1/orders/estacion/latido", {
    method: "POST",
    headers: conJson(headers),
    body: JSON.stringify({ venue_id: venueID, label: etiqueta }),
  });
}

/** Quién está imprimiendo. `null` si nadie, o si no se pudo preguntar. */
export function verEstacion(headers) {
  return pedir("/v1/orders/estacion", { headers });
}

/**
 * Coge el turno de imprimir esta comanda.
 *
 * Se reclama ANTES de imprimir: el servidor solo deja ganar a uno, así que dos
 * aparatos no pueden sacar el mismo papel. Devuelve `false` si llegó tarde.
 */
export async function reclamar(orderId, headers) {
  const r = await pedir(`/v1/orders/${orderId}/reclamar-impresion`, { method: "POST", headers });
  return Boolean(r?.reclamada);
}

/** La impresión falló: devuelve la comanda a la cola en vez de darla por impresa. */
export function soltar(orderId, headers) {
  return pedir(`/v1/orders/${orderId}/soltar-impresion`, { method: "POST", headers });
}

/** Una pantalla sin impresora pide que se repita el ticket. */
export function pedirReimpresion(orderId, headers) {
  return pedir(`/v1/orders/${orderId}/pedir-reimpresion`, { method: "POST", headers });
}
